import { FC, useState } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import NormativeVersionForm from "./NormativeVersionForm";

const AddNormativeVersionButton: FC = () => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);
  const { normativeId } = useParams<{ normativeId: string }>();

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>
        {i18n.translation.normativeVersions.add}
      </Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.normativeVersions.createNew}>
          {normativeId && (
            <NormativeVersionForm normativeId={normativeId} onClose={() => setShowNewItemDialog(false)} />
          )}
        </ModalDialog>
      )}
    </>
  );
};

export default AddNormativeVersionButton;
